export const environment = {
  production: false,
  apiUrl: 'https://fastapi.fastglobe.in/api',
};
